var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 44,
    viewBox: "0 0 53 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-30 -772) translate(-6 759) translate(35 12.5) rotate(-12 44.752 3.238)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.577,
    height: 27.498,
    fill: "#0388D3",
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    d: "M0 4.435H42.577V9.757H0z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#F1565B",
    transform: "translate(-30 -772) translate(-6 759) translate(35 12.5) translate(10.644 16.851)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.577,
    height: 27.498,
    rx: 4
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFD100",
    transform: "translate(-30 -772) translate(-6 759) translate(35 12.5) translate(10.644 16.851) translate(2.661 10.644)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.983,
    height: 1.774,
    x: 9.757,
    y: 9.757,
    rx: 0.887
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.983,
    height: 1.774,
    y: 9.757,
    rx: 0.887
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.983,
    height: 1.774,
    x: 29.272,
    y: 9.757,
    rx: 0.887
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.983,
    height: 1.774,
    x: 19.515,
    y: 9.757,
    rx: 0.887
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.757,
    height: 6.209,
    x: 27.498,
    rx: 2
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.2148a15c5d485535d5005bef3ca9c3f8.svg";
export { ForwardRef as ReactComponent };